import { logErrorAndEventuallyReportToBimBamBoom } from "../utils/logging"
import { FeatureFlagValues, parseFlag } from "./types"

declare global {
  interface Window {
    __DEFAULT_FEATURE_FLAGS__: undefined | Partial<FeatureFlagValues>
  }
}

const BUILD_TIME_OVERRIDES: Partial<Record<keyof FeatureFlagValues, boolean>> = {
  localMode: getBuildTimeFlag('REACT_APP_LOCAL_MODE'),
  singleLogin: getBuildTimeFlag('REACT_APP_SINGLE_LOGIN_PREVIEW'),
}

const DEFAULT_FALLBACK: FeatureFlagValues = {
  singleLogin: false,
  localMode: false,
  selectableWidgets: {
    names: {
      allowed: [],
      blocked: [],
    },
    categories: {
      allowed: [],
      blocked: [],
    },
    defaultPolicy: 'allowed',
  },
  codeWidget: {
    enabled: false,
    crossOriginRepoUrlAllowed: false,
  }
}

export function getDefault<K extends keyof FeatureFlagValues>(flag: K): FeatureFlagValues[K] {
  if (flag in BUILD_TIME_OVERRIDES && BUILD_TIME_OVERRIDES[flag]) {
    return true as FeatureFlagValues[K]
  }

  const fallback =  DEFAULT_FALLBACK[flag]
  const defaultValue = window.__DEFAULT_FEATURE_FLAGS__?.[flag]
  if (defaultValue == null) return fallback
  try {
    parseFlag(flag, defaultValue, (e) => {
      logErrorAndEventuallyReportToBimBamBoom(`window.__DEFAULT_FEATURE_FLAGS__.${flag} was found not to match schema`, e)
    })
    return defaultValue
  } catch (e) {
    logErrorAndEventuallyReportToBimBamBoom(`window.__DEFAULT_FEATURE_FLAGS__.${flag} was found not to match schema`, e)
    return fallback
  }
}

function getBuildTimeFlag(envKey: string): boolean {
  const buildTimeValue = process.env[envKey]
  if (buildTimeValue == null) return false
  try {
    return JSON.parse(buildTimeValue) === true
  } catch {
    return false
  }
}
